import axios from "axios";
import { useToast } from "vue-toastification";
import { getUserToken } from "@/utils/getUserToken";

const publicRoutes = ["/view-trucks"];

export const serviceInstance = axios.create({
  headers: {
    // "Access-Control-Allow-Origin": "*",
    // Authorization: `Bearer ${getUserToken()?.token}`,
  },
});

serviceInstance.interceptors.request.use(
  (config) => {
    let token = getUserToken()?.token;

    config.headers["Authorization"] = `Bearer ${token}`;

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

serviceInstance.interceptors.response.use(undefined, (err) => {
  const toast = useToast();
  const error = err.response;
  const errorStatus = err.status;
  const responseError = err.message;
  const errorList = err.response?.data?.errors;
  const customError = err.response?.data?.message
    ? err.response?.data?.message
    : err.response?.data?.title
    ? err.response?.data?.title
    : err?.response?.data;
  const finalErrorMsg = customError ? customError : responseError;

  console.log(err, "errrr");
  toast.error(err)

  if (
    error.status === 401 &&
    (!err.config.url || !err.config.url.includes("/Login"))
  ) {
    toast.error(customError || "Session expired. Please log in again.", {
      timeout: 2000,
    });
    sessionStorage.clear();
    localStorage.clear();
    window.location = "/login";
  } else {
    //show multiple errors
    if (finalErrorMsg == "One or more validation errors occurred.") {
      for (let error in errorList) {
        toast.error(errorList[error][0]);
      }
    } else {
      //show single error
      toast.error(`${finalErrorMsg} ${errorStatus ? errorStatus : ""}`);
    }
  }

  return Promise.reject(err);
});

// const accessToken = window.localStorage.getItem("user-token");
// if (accessToken) {
//   serviceInstance.defaults.headers.common[
//     "Authorization"
//   ] = `Bearer ${accessToken}`;
// }

// export const setToken = (token) => {
//   if (token) {
//     serviceInstance.defaults.headers.common[
//       "Authorization"
//     ] = `Bearer ${token}`;
//   }
// };
